// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".btnBox {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n.serach {\n  margin-bottom: 10px;\n}\n.goods-content {\n  max-height: 70vh;\n  overflow-y: auto;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
